
export default {
	webUrl: 'http://127.0.0.1:8000',
	staticUrl: 'http://127.0.0.1:8000/static/image/'
}



// WEBPACK FOOTER //
// ./src/common/config.js